import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import { LANGUAGE_CODES } from 'Douleutaras/constants/system';
import 'Douleutaras/configuration/datePicker';

import './CustomDatepicker.scss';

const CustomDatepicker = ({ datepickerProps }) => {
  const [startDate, setStartDate] = useState(undefined);
  const { t } = useTranslation();
  const currentLang = i18n.language as LANGUAGE_CODES;

  return (
      <DatePicker selected={startDate}
                  onChange={date => setStartDate(date)}
                  placeholderText={t('DATEPICKER.SELECT-DATE')}
                  calendarStartDay={1}
                  locale={currentLang}
                  { ...datepickerProps }
      />
  );
};

export default CustomDatepicker;
